module.exports = __webpack_public_path__ + "static/media/K.fb80aa2c.jpg";